import { forwardRef } from 'react';

import { SvgStyled } from '@sternum/web/icons/icons.styles';
import { IconProps } from '@sternum/web/icons/icons.types';

export const CodeSandboxCubeIcon = forwardRef<SVGSVGElement, IconProps>(function CodeSandboxCubeIcon(
  { color = '', height = 12, width = 12, hasCursorPointer = false, ...props },
  ref,
) {
  return (
    <SvgStyled
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-has-cursor-pointer={hasCursorPointer}
      {...props}
    >
      <path
        d="M10.8453 2.65361C11.4088 2.33506 11.6906 2.17578 12 2.17578C12.3094 2.17578 12.5912 2.33506 13.1547 2.65361L19.8453 6.43561C20.4088 6.75416 20.6906 6.91344 20.8453 7.17578C21 7.43812 21 7.75667 21 8.39377L21 15.9578C21 16.5949 21 16.9134 20.8453 17.1758C20.6906 17.4381 20.4088 17.5974 19.8453 17.9159L13.1547 21.698C12.5912 22.0165 12.3094 22.1758 12 22.1758C11.6906 22.1758 11.4088 22.0165 10.8453 21.698L4.1547 17.9159C3.59117 17.5974 3.3094 17.4381 3.1547 17.1758C3 16.9134 3 16.5949 3 15.9578L3 8.39377C3 7.75667 3 7.43812 3.1547 7.17578C3.3094 6.91344 3.59117 6.75416 4.1547 6.43561L10.8453 2.65361Z"
        stroke={color || 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.5 4.44629L13.134 5.7264C12.5803 6.02598 12.3035 6.17576 12 6.17576C11.6965 6.17576 11.4197 6.02598 10.866 5.7264L8.5 4.44629"
        stroke={color || 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 11.7912L12 22.1758M12 11.7912L20.5 7.17578M12 11.7912L3.5 7.17578"
        stroke={color || 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 12.1758L5.89443 13.7343C6.43234 14.024 6.7013 14.1688 6.85065 14.429C7 14.6893 7 15.0131 7 15.6608L7 19.1758"
        stroke={color || 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 12.1758L18.1056 13.7343C17.5677 14.024 17.2987 14.1688 17.1493 14.429C17 14.6893 17 15.0131 17 15.6608V19.1758"
        stroke={color || 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgStyled>
  );
});
